import http from '@/service/http'

const api = {}
/**
 * API GET generale
 * @function
 * @async
 * @todo Intercettare gli errori
 */
api.get = async function(endpoint, filter) {
  let url = '/' + endpoint
  url += '?filter=' + encodeURIComponent(JSON.stringify(filter))
  const response = await http.get(url)
  if (response.status === 200) {
    return response.data
  }
}
api.getCustom = async function(endpoint, methodName, parameters) {
  let url = endpoint + '/' + methodName + '?'
  if (parameters) {
    Object.keys(parameters).map(key => {
      url += key + '=' + parameters[key] + '&'
    })
    url = url.substring(0, url.length - 1)
  }
  const response = await http.get(url)
  if (response.status === 200) {
    return response.data
  }
}
/**
 * API GetById generale
 * @function
 * @async
 * @todo Intercettare gli errori
 * @param {string} endpoint - Il nome dell'endpoint es: TzbCourses
 * @param {string} id - ricerca ID
 * @param {string} [filter] - Campi ES: {include: {id: true}}
 */
api.getById = async function(endpoint, id, query) {
  // const query = {
  //   include: include,
  //   fields: fields,
  //   limit: limit,
  // }
  if (id) {
    let url = '/' + endpoint + '/' + id
    if (query) url += '?filter=' + encodeURIComponent(JSON.stringify(query))
    const response = await http.get(url)
    if (response.status === 200) {
      return response.data
    }
  }
}
/**
 * API PATCH generale
 * @function
 * @async
 * @todo Intercettare gli errori
 * @param {string} endpoint - Il nome dell'endpoint es: TzbCourses
 * @param {object} obj - Oggetto da aggiornarte
 */
api.patch = async function(endpoint, obj) {
  const query = '/' + endpoint + '/'
  const response = await http.patch(query, obj)
  if (response.status === 200) {
    return response.data
  }
}
/**
 * API PUT generale
 * @function
 * @async
 * @todo Intercettare gli errori
 * @param {string} endpoint - Il nome dell'endpoint es: TzbCourses
 * @param {object} obj - Oggetto da aggiornarte
 */
api.put = async function(endpoint, obj) {
  const query = endpoint
  const response = await http.put(query, obj)
  if (response.status === 200) {
    return response.data
  }
}
/**
 * API POST generale
 * @function
 * @async
 * @todo Intercettare gli errori
 * @param {string} endpoint - Il nome dell'endpoint es: TzbCourses
 * @param {object} obj - Oggetto da aggiornarte
 */
api.post = async function(endpoint, obj) {
  const query = endpoint
  const response = await http.post(query, obj)
  if (response.status === 200) {
    return response.data
  }
}
/**
 * API DELETE generale
 * @function
 * @async
 * @todo Intercettare gli errori
 * @param {string} endpoint - Il nome dell'endpoint es: TzbCourses
 * @param {string} id - ricerca ID
 */
api.delete = async function(endpoint, id, where) {
  if (!where) where = {}
  else where = { where: where }
  let query = '/' + endpoint
  if (id) query += '/' + id
  query += '?filter=' + encodeURIComponent(JSON.stringify(where))
  const response = await http.delete(query)
  if (response.status === 200) {
    if (response.data.count !== 0) console.log(response.data)
    return response.data.count
  }
}
api.deleteCustom = async function(endpoint, methodName, parameters) {
  let url = endpoint + '/' + methodName + '?'
  if (parameters) {
    Object.keys(parameters).map(key => {
      url += key + '=' + parameters[key] + '&'
    })
    url = url.substring(0, url.length - 1)
  }
  const response = await http.delete(url)
  if (response.status === 200) {
    return response.data
  }
}
/**
 * API di conteggio degli Endpoint
 * @function
 * @async
 * @todo Intercettare gli errori
 * @param {string} endpoint - Il nome dell'endpoint es: TzbCourses
 * @param {object} [where] - Query di ricerca ES: {id:1}
 */
api.count = async function(endpoint, where) {
  let url = endpoint + '/count'
  if (where) url += '?where=' + JSON.stringify(where)
  const response = await http.get(url)
  if (response.status === 200) {
    return response.data.count
  }
}
/**
 * API per richiamare un custom method
 * @function
 * @async
 * @param {string} endpoint - Il nome dell'endpoint es: TzbCourses
 * @param {string} methodName - Il nome del methodo da richiamare: es. getPresence
 * @param {object} [parameters] - Parametri es. {courseId:123232c} o  oggetto:{dataToSend:{courseId: 1424141}
 */

export default { api }



// WEBPACK FOOTER //
// ./src/api.js